import { render, staticRenderFns } from "./duo_chat_delete_thread_modal.vue?vue&type=template&id=8e63beb8"
import script from "./duo_chat_delete_thread_modal.vue?vue&type=script&lang=js"
export * from "./duo_chat_delete_thread_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports